module.exports = __webpack_public_path__ + "static/img/pic-shuo-1@2x.9369af6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/pic-shuo-1@2x.png
// module id = 191
// module chunks = 0